/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export const focusOnEmptyPasswordField = (
  event: Event,
  signUpPasswordValue: string,
  confirmPassword: string
) => {
  const emptyInputPassword = (event.target as HTMLFormElement).querySelector(
    'input[name="password"]'
  );
  const emptyInputConfirmPassword = (
    event.target as HTMLFormElement
  ).querySelector('input[name="confirmPasswordField"]');

  if (emptyInputPassword && !signUpPasswordValue.length) {
    (emptyInputPassword as HTMLInputElement).focus();
  } else if (emptyInputConfirmPassword && !confirmPassword.length) {
    (emptyInputConfirmPassword as HTMLInputElement).focus();
  }
};
